<template>
    <div>
        <v-row>
            <v-card
                    class="full-bck fullInfoInner"
                    width="880"
            >
                <v-card-text >
                        <div class="scroll">
                    <div class="full-heading mt-1">Full Info</div>

                    <v-row>
                        <v-col col="sm-6">
                            <p class="full-label">First Name</p>
                            <p class="full-info">{{applicant.firstName}}</p>
                        </v-col>
                        <v-col col="sm-6">
                            <p class="full-label">Last Name</p>
                            <p class="full-info">{{applicant.lastName}}</p>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col col="sm-6">
                            <p class="full-label">Email Address</p>
                            <p class="full-info ">{{applicant.applicantDocument.email}}</p>
                        </v-col>
                        <v-col col="sm-6">
                            <p class="full-label">Phone Number</p>
                            <p class="full-info">{{applicant.phone}}</p>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col col="sm-6">
                            <p class="full-label">Gender</p>
                            <p class="full-info">{{applicant.gender}}</p>
                        </v-col>
                        <v-col col="sm-6">
                            <p class="full-label">Region</p>
                            <p class="full-info">{{applicant.applicantDocument.region}}</p>

                        </v-col>

                    </v-row>

                    <v-row>

                            <v-col class="col-6"  v-for="(label,index) in applicantDataLabel" :key="label._id" :style="[applicantDataValue[index]===''?{display:'none'}:{display: 'block'}]">

                                <p   class="full-label">{{label}}</p>
                                    <p v-if="label==='Age'" class="full-info">{{convertDate}}</p>
                            <p v-else class="full-info">{{(applicantDataValue[index]).toLocaleString()}}</p>
                            </v-col>

                    </v-row>

                    </div>
                </v-card-text>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";




    export default {
        name: "FullInfo",
        data(){
            return{
                convertDate:'',
                applicantDataLabel:'',
                applicantDataValue:'',
                questionnaireData:{}
            }
        },
        computed: mapGetters([
            'applicant'
        ]),


        mounted() {
        //    let dateOfBirth = questionnaire.dateOfBirth;
            //this.convertDate = new Date().getFullYear() - dateOfBirth.toString().substr(0,4)
            this.convertDate = this.calculateAge();
            const questionnaire = this.applicant.applicantDocument.questionnaire;
            this.questionnaireData = questionnaire.github !=null ? {
                "Age": questionnaire.dateOfBirth,
                "Marital Status": questionnaire.maritalStatus,
                "Nationality": questionnaire.nationality,
                "State of Origin": questionnaire.stateOfOrigin,
                "Country of Residence": questionnaire.countryOfResidence,
                "State of Residence": questionnaire.stateOfResidence,
                "Able to commit": questionnaire.commitToProgram,
                "Able to relocate": questionnaire.relocateForProgram,
                "Programming Languages": questionnaire.programmingLanguage,
                "Database": questionnaire.database,
                "Frameworks": questionnaire.frameworks,
                "Operating Systems": questionnaire.operatingSystems,
                "Why I applied": questionnaire.whyApply,
                "Highest Education": questionnaire.highestEducation,
                "Doctorate Course of Study": questionnaire.doctorateCourseField,
                "Doctorate Institution": questionnaire.doctorateInstitutionField,
                "Doctorate Grade": questionnaire.doctorateGradGrade,
                "Doctorate Year": questionnaire.doctorateGradYear,
                "Masters Course of Study": questionnaire.mastersCourseField,
                "Masters Institution": questionnaire.mastersInstitutionField,
                "Masters Grade": questionnaire.mastersGradGrade,
                "Masters Year": questionnaire.mastersGradYear,
                "Undergraduate Institution": questionnaire.underGradInstitution,
                "Undergraduate Course of Study": questionnaire.underGradCourse,
                "Undergraduate Type": questionnaire.underGradDegreeType,
                "Undergraduate Grade": questionnaire.underGradGrade,
                "Undergraduate Year": questionnaire.underGradGradYear,
                "Currently": questionnaire.iAmCurrently,
                "Where I currently Work": questionnaire.whereWorkCurrently,
                "NYSC status": questionnaire.nyscStatus,
                "Alternate Phone": questionnaire.alternatePhone,
                "Whatsapp": questionnaire.whatsapp,
                "Twitter": questionnaire.twitter,
                "Instagram": questionnaire.instagram,
                "Tiktok": questionnaire.tiktok,
                "Github": questionnaire.github,
                "LinkedIn": questionnaire.linkedin,
                "Facebook": questionnaire.facebook,
                "Telegram": questionnaire.telegram,
                "Preferred Social Media": questionnaire.mostPreferredSocialNetwork
              }
            :

              {
                "Age": questionnaire.dateOfBirth,
                "Marital Status": questionnaire.maritalStatus,
                "Nationality": questionnaire.nationality,
                "State of Origin": questionnaire.stateOfOrigin,
                "Country of Residence": questionnaire.countryOfResidence,
                "State of Residence": questionnaire.stateOfResidence,
                "Able to commit": questionnaire.commitToProgram,
                "Able to relocate": questionnaire.relocateForProgram,
                "Programming Languages": questionnaire.programmingLanguage,
                "Database": questionnaire.database,
                "Frameworks": questionnaire.frameworks,
                "Operating Systems": questionnaire.operatingSystems,
                "Why I applied": questionnaire.whyApply,
                "Highest Education": questionnaire.highestEducation,
                "Doctorate Course of Study": questionnaire.doctorateCourseField,
                "Doctorate Institution": questionnaire.doctorateInstitutionField,
                "Doctorate Grade": questionnaire.doctorateGradGrade,
                "Doctorate Year": questionnaire.doctorateGradYear,
                "Masters Course of Study": questionnaire.mastersCourseField,
                "Masters Institution": questionnaire.mastersInstitutionField,
                "Masters Grade": questionnaire.mastersGradGrade,
                "Masters Year": questionnaire.mastersGradYear,
                "Undergraduate Institution": questionnaire.underGradInstitution,
                "Undergraduate Course of Study": questionnaire.underGradCourse,
                "Undergraduate Type": questionnaire.underGradDegreeType,
                "Undergraduate Grade": questionnaire.underGradGrade,
                "Undergraduate Year": questionnaire.underGradGradYear,
                "Where I currently Work": questionnaire.whereWorkCurrently
              }

            this.applicantDataLabel = Object.keys(this.questionnaireData)
            this.applicantDataValue = Object.values(this.questionnaireData)




        },
      methods: {
        calculateAge () {
          const questionnaire = this.applicant.applicantDocument.questionnaire;

          let serverDateOfBirth = questionnaire.dateOfBirth;

          if (serverDateOfBirth === undefined) return;
          let arrAge = serverDateOfBirth.split('-');
          let [year, month, day] = arrAge;


          month = --month; //month counts from zero and not one, decrementing by one consolidates it

          let dateOfBirth = new Date(Number(year), Number(month), Number(day));
          let currentDate = new Date();

          let currentAge = currentDate.getFullYear() - dateOfBirth.getFullYear();
          let monthDifference = currentDate.getMonth() - dateOfBirth.getMonth();

          if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < dateOfBirth.getDate())) {
            currentAge--;
          }
          return currentAge;
        }


      }

    }

</script>

<style scoped>
    .full-bck{
        background: #FFF2C7;
        border-radius: 16px;
    }
    .full-heading{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 21px;
        line-height: 27px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #960C0C;
    }
    .scroll{
        overflow-y: scroll;
        max-height: 430px;
        height: 430px;
        overflow-x: hidden;
        margin-right: 40px;
        width: 550px;
    }
    p{
        margin-bottom: 7px !important;

    }
    .full-label{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        margin-left: 7px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #2B1C1C;
    }
    div.col{
        padding: 5px !important;
    }
    .full-info{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        margin-left: 7px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #2B1C1C !important;


    }
    /*.fullInfoInner {*/
    /*    width: 100%;*/
    /*    !*overflow-y: scroll;*!*/
    /*    !*overflow-x: hidden;*!*/
    /*    max-height: 430px;*/
    /*    height: 430px;*/
    /*    !*margin-top: 20px;*!*/
    /*}*/

</style>